import axios from "axios";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropTypes } from "prop-types";
import imgLogo from "../../../../../image/logo.png";
import api from "../../../../../utils/apidsf";
import swal from "sweetalert";
import RichTextEditor from "react-rte";
import { GetToken } from "../../../../../actions/userAction.js";
import { useDispatch, useSelector } from "react-redux";
import "./CreateArticle.css";

// components
import FormField from "../../../Components/FormField/FormField";

export default function CreateArticle() {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selector = useSelector((state) => state);
  //const [id, setId] = useState("");
  const [textareadata, settextdata] = useState({
    value: RichTextEditor.createEmptyValue(),
  });
  const [filetoken, setfiletoken] = useState("");
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    RechtextforDescription: RichTextEditor.createEmptyValue(),
    category: "state",
  });
  const [show, setshow] = useState(false);

  console.log(formData);
  useEffect(() => {
    dispatch(GetToken());
  }, []);
  useEffect(() => {
    setfiletoken(selector?.adminReducer?.token);
  }, [selector]);

  const handleInputChange = (e) => {
    setFormData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let id = params.id;
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };

    const createOrUpdateLandmark = async () => {
      try {
        let res = null;
        if (id) {
          res = await api.put(`/admin/legal-essay/${id}`, formData, config);
        } else {
          res = await api.post("/admin/legal-essay", formData, config);
        }
        const data = res.data.data;

        if (data && id) {
          swal({
            title: "Legal Essay Updated",
            text: "Legal Essay Updated Successfully",
            icon: "success",
          });
          navigate("/admin/legalessay-table");
        } else {
          setFormData({
            ...formData,
            title: "",
            description: "",
            RechtextforDescription: RichTextEditor.createEmptyValue(),
          });
          swal({
            title: "Legal Essay Added",
            text: "Legal Essay Added Successfully",
            icon: "success",
          });
          // show error
        }
      } catch (err) {
        console.error(err.response.data.error);
        swal({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
        });
      }
    };
    createOrUpdateLandmark();
  };

  useEffect(() => {
    let id = params.id;

    const fetchLandmark = async () => {
      let token = JSON.parse(localStorage.getItem("token"));

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      const res = await api.get(`/admin/legal-essay/${id}`, config);
      const data = res.data.data;
      const { title, category, description } = data;

      setFormData({
        category: category,
        title: title,
        description: description,
        RechtextforDescription: RichTextEditor.createValueFromString(
          description,
          "html"
        ),
      });
    };

    if (id) {
      fetchLandmark();
    } else {
      setFormData({
        title: "",
        description: "",
        RechtextforDescription: RichTextEditor.createEmptyValue(),
        category: "state",
      });
    }
  }, [params]);

  const onChange = (value) => {
    let data = value.toString("html");

    setFormData({
      ...formData,
      description: data,
      RechtextforDescription: value,
    });
  };

  const { title, category, description } = formData;
  return (
    <div style={{ flex: 4 }}>
      <form action="" className="admin__userUpdateForm" onSubmit={handleSubmit}>
        <div className="userUpdateLeft">
          <FormField
            type="text"
            label="Title"
            placeholder="Title"
            value={title}
            name="title"
            handleChange={handleInputChange}
          />

          <div className="userUpdateItem">
            <label className="user__label">Category</label>
            <select
              value={category}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  category: e.target.value,
                });
              }}
            >
              <option value="state">State</option>
              <option value="center">center</option>
            </select>
          </div>

          <div className="userUpdateItem">
            <label className="user__label">Description</label>

            <RichTextEditor
              className="desc_area"
              value={formData?.RechtextforDescription}
              onChange={onChange}
            />
          </div>

          <div>
            <button className="userUpdateButton" type="submit">
              {params.id ? "Update Article" : "Add Article"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
